import { Injectable } from '@angular/core';
import { Adapter } from '@supoui/shared/interfaces/adapter';
import { CaseDocumentTag, CaseDocumentTagAdapter } from './case-document-tag';

export class CaseDocument {
  documentName: string;
  documentExtension: string;
  documentId: string;
  documentType: string;
  documentDate: Date | null;
  isOutgoing: boolean;
  sender: string;
  recipient: string;
  caseDocumentTags: CaseDocumentTag[];
  comments: string;
  status: string;
  unhandled: boolean;
  deleted: boolean;
  deletedBy: string;

  public constructor(init?: Partial<CaseDocument>) {
    Object.assign(this, init);
  }
}

@Injectable({
  providedIn: 'root'
})
export class CaseDocumentAdapter implements Adapter<CaseDocument> {
  constructor(private caseDocumentTagAdapter: CaseDocumentTagAdapter) {}

  adapt(item: any): CaseDocument {
    const documentFileName = item.documentName.split('.');
    return new CaseDocument({
      documentName: documentFileName[0],
      documentExtension: documentFileName[1],
      documentId: item.documentId,
      documentDate: item.creationDate === '' ? null : new Date(item.creationDate),
      isOutgoing: item.outgoing,
      documentType: item.documentType,
      sender: item.sender,
      recipient: item.recipient,
      caseDocumentTags: item.caseDocumentTags ? item.caseDocumentTags.map((tag: any) => this.caseDocumentTagAdapter.adapt(tag)) : undefined,
      status: item.documentStatus,
      comments: item.comments,
      unhandled: item.unhandled,
      deleted: item.deleted,
      deletedBy: item.deletedBy
    });
  }
}
